import React from 'react'
import Notification from '@ynap/notification'
import BEMHelper from '@ynap/bem-helper'

const bem = new BEMHelper('CookiesNotification')

export const CookiesNotification = ({ title, message }) => {
    return (
        <div className={bem()}>
            <h2 className={bem('title')}>{title}</h2>
            <Notification className={bem('message')} type="info" message={message} />
        </div>
    )
}
